export const ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  HR_ADMIN: 'HR_ADMIN',
  LINE_MANAGER: 'LINE_MANAGER',
  EMPLOYEE: 'EMPLOYEE',
};

export const ROLE_LABELS = {
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.HR_ADMIN]: 'HR Admin',
  [ROLES.LINE_MANAGER]: 'Line Manager',
  [ROLES.EMPLOYEE]: 'Employee',
};

export const MENU_PERMISSIONS = {
  dashboard: [ROLES.SUPER_ADMIN, ROLES.HR_ADMIN, ROLES.LINE_MANAGER, ROLES.EMPLOYEE],
  employees: [ROLES.SUPER_ADMIN, ROLES.HR_ADMIN, ROLES.LINE_MANAGER],
  attendance: [ROLES.SUPER_ADMIN, ROLES.HR_ADMIN, ROLES.LINE_MANAGER, ROLES.EMPLOYEE],
  leave: [ROLES.SUPER_ADMIN, ROLES.HR_ADMIN, ROLES.LINE_MANAGER, ROLES.EMPLOYEE],
  // Self-service payslips for managers/employees; full payroll for HR/admin
  payroll: [ROLES.SUPER_ADMIN, ROLES.HR_ADMIN, ROLES.LINE_MANAGER, ROLES.EMPLOYEE],
  assets: [ROLES.SUPER_ADMIN, ROLES.HR_ADMIN],
  masters: [ROLES.SUPER_ADMIN, ROLES.HR_ADMIN],
  settings: [ROLES.SUPER_ADMIN, ROLES.HR_ADMIN],
  audit: [ROLES.SUPER_ADMIN, ROLES.HR_ADMIN],
  profile: [ROLES.SUPER_ADMIN, ROLES.HR_ADMIN, ROLES.LINE_MANAGER, ROLES.EMPLOYEE],
};

export const canAccess = (role, menuKey) => MENU_PERMISSIONS[menuKey]?.includes(role) ?? false;
